export default ".choose_formulaire_list {\n  max-height: 40vh;\n  overflow-y: auto;\n}"